<template>
  <Form :customTable="customTable" @saveModel="sendToShow($event)"/>
</template>

<script>
  import Form from '@/components/admin/custom_tables/Form'

  export default {
    components: { Form },
    data() {
      return {
        customTable: {}
      }
    },
    methods: {
      sendToShow(customTable) {
        this.$ss.set('tempCustomTable', customTable, { minutes: 1 })
        this.$router.push(`/admin/custom_tables/${customTable.id}`)
      }
    },
    name: 'New'
  }
</script>

<style scoped>

</style>